import Icon from '../../components/Icon.vue'

Icon.register({"brands/vuejs":{"width":448,"height":512,"paths":[{"d":"M356.9 64.3H280L224 152.9 176 64.3H0L224 448 448 64.3H356.9zM55.7 96.3H109.5L224 294.5 338.4 96.3H392.2L224 384.5 55.7 96.3z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/brands/vuejs.js
// module id = null
// module chunks = 